import {
	registerDecorator,
	ValidationArguments,
	ValidationOptions,
	ValidatorConstraint,
	ValidatorConstraintInterface,
} from 'class-validator';

@ValidatorConstraint({ name: 'noUnfilledParams', async: false })
export class NoUnfilledParamsConstraint implements ValidatorConstraintInterface {
	private static readonly PARAMS_REGEX = /\{\{[^}]+\}\}/g;

	validate(text: string, args: ValidationArguments) {
		if (typeof text !== 'string') return true;
		return !NoUnfilledParamsConstraint.PARAMS_REGEX.test(text);
	}

	defaultMessage(args: ValidationArguments) {
		const text = args.value as string;
		const matches = text?.match(NoUnfilledParamsConstraint.PARAMS_REGEX);

		if (matches && matches.length > 0) {
			return `${matches.join(', ')} - must be replaced with a value`;
		}

		return 'String contains unfilled parameters';
	}
}

export function NoUnfilledParams(validationOptions?: ValidationOptions) {
	return function (object: Object, propertyName: string | symbol) {
		registerDecorator({
			target: object.constructor,
			propertyName: propertyName.toString(),
			options: validationOptions,
			constraints: [],
			validator: NoUnfilledParamsConstraint,
		});
	};
}
